import React, { useState } from 'react';
import { db } from '../../firebase/config'; // Import the database connection
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'; // Import the specific firestore functions

const AddNoteModal = ({ isOpen, onClose, user, customerId, currentStatus, onStatusChange, currentUserProfile }) => {
    const [contactType, setContactType] = useState('Email');
    const [noteText, setNoteText] = useState('');
    const [status, setStatus] = useState(currentStatus);

    const handleSave = async (e) => {
        e.preventDefault();
        if (!noteText.trim() || !currentUserProfile?.organizationId) return;

        const notesCollectionPath = `organizations/${currentUserProfile.organizationId}/customers/${customerId}/notes`;
        await addDoc(collection(db, notesCollectionPath), {
            contactDate: serverTimestamp(),
            contactType,
            noteText,
            status: status,
            createdBy: user?.uid || '',
            createdByName: currentUserProfile?.name || user?.email || '',
        });
        
        if (status !== currentStatus) {
            onStatusChange(status);
        }

        onClose();
    };
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-[60]">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                <h2 className="text-lg font-bold mb-4">Add Contact Note</h2>
                <form onSubmit={handleSave}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Contact Date</label>
                        <input
                            type="text"
                            value={new Date().toLocaleString()}
                            className="mt-1 w-full p-2 border border-gray-300 rounded-md bg-gray-100"
                            disabled
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Type of Contact</label>
                        <select
                            value={contactType}
                            onChange={(e) => setContactType(e.target.value)}
                            className="mt-1 w-full p-2 border border-gray-300 rounded-md"
                        >
                            <option>Initial Email</option>
                            <option>Initial Call</option>
                            <option>In-person</option>
                            <option>Email</option>
                            <option>Phone</option>
                            <option>Text</option>
                        </select>
                    </div>
                    <div className="mb-4">
                         <label className="block text-sm font-medium text-gray-700">Update Status</label>
                         <select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className="mt-1 w-full p-2 border border-gray-300 rounded-md"
                        >
                            <option>New</option>
                            <option>Contacted</option>
                            <option>Proposal Sent</option>
                            <option>Closed</option>
                            <option>Lost</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Notes</label>
                        <textarea
                            rows="4"
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                            className="mt-1 w-full p-2 border border-gray-300 rounded-md"
                            required
                        ></textarea>
                    </div>
                    <div className="flex justify-end space-x-4">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Save Note</button>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default AddNoteModal;